import React from 'react'
import { TextField } from '@deal/components'
import { NumericPathFlowQuestionProps } from '../'
import { getInputUnit } from '#src/services/path'
import styles from './styles.css'

interface NumericQuestionState {
  isValid?: boolean
  errorText?: string
}

class NumericQuestion extends React.PureComponent<
  NumericPathFlowQuestionProps,
  NumericQuestionState
> {
  constructor(props: NumericPathFlowQuestionProps) {
    super(props)

    this.state = {}

    if (!props.question.required) {
      this.props.onFieldValidityChanged(true)
    }

    if (props.value) {
      this.props.onFieldValueChanged({ value: props.value })
      this.props.onFieldValidityChanged(true)
    }

    this.handleIsFieldValid = this.handleIsFieldValid.bind(this)
    this.handleSetFieldValid = this.handleSetFieldValid.bind(this)
    this.handleSetFieldInvalid = this.handleSetFieldInvalid.bind(this)
  }

  public handleIsFieldValid(value: string) {
    const { question } = this.props
    const isRequired = question.required
    let isFieldValid = true

    if (value === undefined && isRequired) {
      isFieldValid = false
    }

    if (value !== undefined && !new RegExp(/^\d+$/).test(value)) {
      isFieldValid = false
    }

    // By default, we're limiting all fields to be less than 1b to  prent Int / Long parsing errors
    if (value !== undefined && parseInt(value, 10) > 1000000000) {
      isFieldValid = false
    }

    return isFieldValid
  }

  public handleSetFieldInvalid() {
    this.setState({
      isValid: false,
      errorText: 'Please enter a valid number'
    })

    this.props.onFieldValidityChanged(false)
  }

  public handleSetFieldValid() {
    this.setState({
      isValid: true,
      errorText: undefined
    })

    this.props.onFieldValidityChanged(true)
  }

  public render() {
    const { question, value } = this.props
    const questionUnit = question.unit ? getInputUnit(question.unit) : undefined

    return (
      <div className={styles.input}>
        <TextField
          label={question.internalName}
          labelHidden={true}
          type="tel"
          display={this.props.display}
          autoFocus={false}
          placeholder={question.placeholder || undefined}
          defaultValue={value ? value.toString() : undefined}
          unit={questionUnit}
          name="number"
          valid={this.state.isValid}
          errorText={this.state.errorText}
          onChange={event => {
            const isFieldValid = this.handleIsFieldValid(event.target.value)

            if (isFieldValid) {
              this.handleSetFieldValid()
            } else {
              this.handleSetFieldInvalid()
            }

            const rawValue = parseInt(event.target.value, 10)
            const value = isNaN(rawValue) ? 0 : rawValue

            this.props.onFieldValueChanged({ value })
          }}
        />
      </div>
    )
  }
}

export default NumericQuestion
